import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { ICurrenciesListItem } from '../../interfaces';

export function useCurrencyInfo(): ICurrenciesListItem {
    return useContext(MobXProviderContext).RootStore.currencyStore.currencyInfo;
}
